<template>
  <div class="flex">
    <FreeInput
      :model-value="modelValue"
      :placeholder="placeholder"
      clearable
      class="text-text-neutral-primary flex h-full grow items-center overflow-hidden"
      @update:modelValue="emit('onInput', $event)"
    >
      <template v-if="Boolean($slots.prepend)" #prepend>
        <slot name="prepend" />
      </template>
      <template v-if="Boolean($slots.append)" #append>
        <slot name="append" />
      </template>
      <template v-if="Boolean($slots.clearButton)" #clearButton>
        <slot name="clearButton" />
      </template>
    </FreeInput>
  </div>
</template>

<script setup lang="ts">
  import { FreeInput } from '../FreeInput';

  defineProps<{
    modelValue?: string;
    placeholder?: string;
  }>();

  const emit = defineEmits<{
    onInput: [value: string];
    onCancel: [];
  }>();
</script>
